import { isStatusValid, validatorConsultaSeguimentoOutro } from '@mchat-rf/consulta-seguimento/utils-consultaSeguimento'
import { createValidator, ErrorObject, required } from 'util/validation'

import { ConsultaSeguimentoPergunta09Model } from './model-consultaSeguimentoPergunta09'
import { hasPergunta09TrazPraVoceAnySim } from './utils-consultaSeguimentoPergunta09'

export const validatorConsultaSeguimentoPergunta09 = createValidator<ConsultaSeguimentoPergunta09Model>(
  {
    resultado: required,
    status: isStatusValid,
    PERGUNTA_09_HEADER: required,
    OUTRO: validatorConsultaSeguimentoOutro,
  },
  (values: ConsultaSeguimentoPergunta09Model, errors: ErrorObject<ConsultaSeguimentoPergunta09Model>) => {
    if (!hasPergunta09TrazPraVoceAnySim(values)) {
      errors.PERGUNTA_09_TRAZ_PRA_VOCE = createValidator<
        ConsultaSeguimentoPergunta09Model['PERGUNTA_09_TRAZ_PRA_VOCE']
      >({
        FIGURA_OU_BRINQUEDO: required,
        DESENHO_QUE_ELE_FEZ: required,
        FLOR_QUE_ELE_PEGOU: required,
        BICHINHO_QUE_ELE_ENCONTROU: required,
        PECAS_QUE_ELE_JUNTOU: required,
      })(values?.PERGUNTA_09_TRAZ_PRA_VOCE)
    }

    if (hasPergunta09TrazPraVoceAnySim(values)) {
      errors.PERGUNTA_09_SO_PARA_MOSTRAR = required(values?.PERGUNTA_09_SO_PARA_MOSTRAR)
    }

    return errors
  }
)
